export const countries = [
  // { code: '+1', label: 'United States', country: 'US' },
  // { code: '+1', label: 'Canada', country: 'CA' },
  { code: '+61', label: 'Australia', country: 'AU' },
  // { code: '+64', label: 'New Zealand', country: 'NZ' },
  // { code: '+27', label: 'South Africa', country: 'ZA' },
  // { code: '+62', label: 'Indonesia', country: 'ID' },
  // { code: '+60', label: 'Malaysia', country: 'MY' },
  // { code: '+65', label: 'Singapore', country: 'SG' },
  // { code: '+675', label: 'Papua New Guinea', country: 'PG' },
  { code: '+63', label: 'Philippines', country: 'PH' },
  // { code: '+44', label: 'United Kingdom', country: 'GB' },
  // { code: '+353', label: 'Ireland', country: 'IE' },
  // { code: '+679', label: 'Fiji', country: 'FJ' },
  // { code: '+267', label: 'Botswana', country: 'BW' },
  // { code: '+237', label: 'Cameroon', country: 'CM' },
  // { code: '+233', label: 'Ghana', country: 'GH' },
  // { code: '+254', label: 'Kenya', country: 'KE' },
  // { code: '+266', label: 'Lesotho', country: 'LS' },
  // { code: '+231', label: 'Liberia', country: 'LR' },
  // { code: '+265', label: 'Malawi', country: 'MW' },
  // { code: '+230', label: 'Mauritius', country: 'MU' },
  // { code: '+264', label: 'Namibia', country: 'NA' },
  // { code: '+234', label: 'Nigeria', country: 'NG' },
  // { code: '+250', label: 'Rwanda', country: 'RW' },
  // { code: '+248', label: 'Seychelles', country: 'SC' },
  // { code: '+232', label: 'Sierra Leone', country: 'SL' },
  // { code: '+268', label: 'Swaziland', country: 'SZ' },
  // { code: '+255', label: 'Tanzania', country: 'TZ' },
  // { code: '+256', label: 'Uganda', country: 'UG' },
  // { code: '+260', label: 'Zambia', country: 'ZM' },
  // { code: '+263', label: 'Zimbabwe', country: 'ZW' },
  // { code: '+1', label: 'Antigua and Barbuda', country: 'AG' },
  // { code: '+1', label: 'Bahamas', country: 'BS' },
  // { code: '+1', label: 'Barbados', country: 'BB' },
  // { code: '+501', label: 'Belize', country: 'BZ' },
  // { code: '+1', label: 'Dominica', country: 'DM' },
  // { code: '+1', label: 'Grenada', country: 'GD' },
  // { code: '+1', label: 'Jamaica', country: 'JM' },
  // { code: '+1', label: 'St. Kitts and Nevis', country: 'KN' },
  // { code: '+1', label: 'St. Lucia', country: 'LC' },
  // { code: '+1', label: 'St. Vincent and the Grenadines', country: 'VC' },
  // { code: '+1', label: 'Trinidad and Tobago', country: 'TT' },
  // { code: '+592', label: 'Guyana', country: 'GY' },
  // { code: '+356', label: 'Malta', country: 'MT' },
  // { code: '+677', label: 'Solomon Islands', country: 'SB' },
  // { code: '+676', label: 'Tonga', country: 'TO' },
  // { code: '+678', label: 'Vanuatu', country: 'VU' },
];
